// removed by extract-text-webpack-plugin
module.exports = {"main":"app-29AP2lSM","icon":"app-1wEPcdUk","other":"app-cMuW_0gE","register":"app-2nE0R2z2"};


//////////////////
// WEBPACK FOOTER
// ./src/wbap-mian-apps/wbap-admin-login/style.less
// module id = 703
// module chunks = 0